import { useRegisterCommands } from "components/Layout/Panels/VSCode/useRegisterCommands";
import { usePitcherCommands } from "hooks/pitcher/usePitcherCommands";

export const useRegisterPitcherCommands = (): void => {
  const { commands, execute } = usePitcherCommands();

  useRegisterCommands(
    execute
      ? commands.map((c) => {
          return {
            id: c.id,
            name: c.displayName,
            section: "Instance",
            perform: () => execute(c.id),
          };
        })
      : [],
    [commands, execute],
  );
};
